import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  SolarProductOfferingPreviewDraft,
  SolarProductOfferingPreviewDto,
} from "../dto/solar-proposal-product-offering.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** How long a draft's preview is reused; the gateway keeps PowurOS inputs for 30 minutes. */
const PREVIEW_STALE_TIME_MS = 30_000

/**
 * The Finance Programs and equipment PowurOS offers a drafted plan, side-effect
 * free. Keyed on the draft, as Battery's equipment preview is, so a program
 * change re-filters the equipment and a stale answer never lands on the
 * current draft.
 */
export default function useSolarProductOfferingPreview(
  proposalId: string | undefined,
  draft: SolarProductOfferingPreviewDraft,
  options?: { enabled?: boolean },
): UseQueryResult<SolarProductOfferingPreviewDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.productOfferingPreview(
      proposalId ?? ``,
      draft,
    ),
    queryFn: ({ signal }) =>
      solarProposalService.previewProductOffering(
        proposalId ?? ``,
        draft,
        signal,
      ),
    enabled: Boolean(proposalId) && (options?.enabled ?? true),
    staleTime: PREVIEW_STALE_TIME_MS,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
